module.exports = __webpack_public_path__ + "img/wifi.148bd844.svg";